<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('联系人')" prop="contactName">
                <a-input v-model="queryParam.contactName" @pressEnter="handleQuery" :maxLength="32" :placeholder="$t('请输入')+$t('联系人')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('联系电话')" prop="contactPhone">
                <a-input v-model="queryParam.contactPhone" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('联系电话')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="status">
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')+$t('状态')" allow-clear>
                  <a-select-option :value="10">{{ $t('待处理') }}</a-select-option>
                  <a-select-option :value="20">{{ $t('已联系') }}</a-select-option>
                  <a-select-option :value="30">{{ $t('已完成') }}</a-select-option>
                  <a-select-option :value="40">{{ $t('已取消') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 处理抽屉 -->
      <handle-form ref="handleForm" @ok="getList" />
      <!-- 详情抽屉 -->
      <a-drawer width="480" :visible="detailVisible" @close="detailVisible = false">
        <a-divider orientation="left"><b>{{ $t('咨询预约详情') }}</b></a-divider>
        <a-descriptions :column="1" bordered size="small" v-if="detail">
          <a-descriptions-item :label="$t('联系人')">{{ detail.contactName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('联系电话')">{{ detail.contactPhone }}</a-descriptions-item>
          <a-descriptions-item :label="$t('意向课程类型')">{{ detail.categoryName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('意向门店/院校')">{{ detail.schoolName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('预约时间')">{{ parseTime(detail.appointTime) }}</a-descriptions-item>
          <a-descriptions-item :label="$t('咨询内容')">{{ detail.content }}</a-descriptions-item>
          <a-descriptions-item :label="$t('状态')">{{ detail.statusName }}</a-descriptions-item>
          <a-descriptions-item :label="$t('处理备注')">{{ detail.handleRemark }}</a-descriptions-item>
          <a-descriptions-item :label="$t('创建时间')">{{ parseTime(detail.createTime) }}</a-descriptions-item>
        </a-descriptions>
      </a-drawer>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="appointTime" slot-scope="text, record">
          {{ parseTime(record.appointTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="statusColor(record.status)">{{ record.statusName }}</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)"><a-icon type="eye" />{{$t('详情')}}</a>
          <template v-if="record.status !== 30 && record.status !== 40">
            <a-divider type="vertical" v-hasPermi="['edu:consult:handle']" />
            <a @click="$refs.handleForm.open(record)" v-hasPermi="['edu:consult:handle']">
              <a-icon type="check" />{{$t('处理')}}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageEduConsult, getEduConsult } from '@/api/edu/consult'
import { mapGetters } from 'vuex'
import HandleForm from './modules/HandleForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'EduConsult',
  components: {
    HandleForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      detailVisible: false,
      detail: null,
      loading: false,
      total: 0,
      queryParam: {
        contactName: null,
        contactPhone: null,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('联系人'),
          dataIndex: 'contactName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('联系电话'),
          dataIndex: 'contactPhone',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('意向课程类型'),
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('意向门店/院校'),
          dataIndex: 'schoolName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('预约时间'),
          dataIndex: 'appointTime',
          scopedSlots: { customRender: 'appointTime' },
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    statusColor(status) {
      switch (status) {
        case 10: return 'orange'
        case 20: return 'blue'
        case 30: return 'green'
        case 40: return 'red'
        default: return 'default'
      }
    },
    /** 查询咨询预约单列表 */
    getList () {
      this.loading = true
      pageEduConsult(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 详情 */
    handleDetail (record) {
      getEduConsult({ "id": record.id }).then(response => {
        this.detail = response.data
        this.detailVisible = true
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        contactName: undefined,
        contactPhone: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
